import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss']
})
export class FacilitiesComponent implements OnInit {

  @Input() isfacilities: boolean = false;
  @Input() isservices: boolean = false;
  @Input() isonlineyoga: boolean = false;
  @Input() isfacilitie: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router) { }
  section: string = '';
  ngOnInit(): void {
    this.route.url.subscribe(() => {
      this.route.firstChild?.data.subscribe(data => {
        if (data['section']) {
          this.section = data['section'];
        }
      });
    });
  }

}
